import { request } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request.get("ai/innerStudy/list/overview", { params });
}

export function Add(params) {
  return request.post("tcm/disease/", params);
}

export function Detail(params) {
  return request.get("ai/innerStudy/list/medicine/overview", { params });
}

export function StudyDetail(params) {
  return request.get("ai/innerStudy/list/medicine/detail", { params });
}

export function Update(params) {
  return request.put("tcm/disease/", params);
}

export function Delete(data) {
  return request.delete("tcm/disease/", { data });
}
